<!-- eslint-disable no-mixed-spaces-and-tabs -->
<template>
  <div id="schedule">
    <template v-if="registration.switch">
      <Apply/>
    </template>
    <template v-else>
      <div class="schedule-container">
        <ui-box bgType="dark">
          <template v-slot:nav-left>
            <ui-tag
              v-for="(season, key) in seasonList"
              :key="key"
              :id="season.id"
              :active="season.id == subSeasonID"
              :data-id="`id-${key}`"
              @click.native="switchSeason(season.id)"
            >
              <div class="label-box">
                <span class="label-shadow">{{ season.name }}</span>
                <span class="label-text">{{ season.name }}</span>
              </div>
            </ui-tag>
          </template>
          <template v-slot:nav-right>
            <div class="nav-right-box">
              <ui-frame-bg class="modal-btn prize" colorType="green" hook @click.native="handleShowPrize">
                <i></i>
                <div class="label-box">
                  <span class="label-shadow">奖金规则</span>
                  <span class="label-text">奖金规则</span>
                </div>
              </ui-frame-bg>
              <ui-frame-bg class="modal-btn rule" colorType="green" hook @click.native="handleShowRule">
                <i></i>
                <div class="label-box">
                  <span class="label-shadow">完整赛制</span>
                  <span class="label-text">完整赛制</span>
                </div>
              </ui-frame-bg>
              
              <div class="switch-match" v-if="phaseList && phaseList.length != 0">
                <ui-frame-bg class="switch-btn" colorType="blue" hook @click.native="showSelect = !showSelect">
                  <div class="label-box">
                    <span class="label-shadow">{{ subMatchName }}</span>
                    <span class="label-text">{{ subMatchName }}</span>
                  </div>
                  <i :class="{ active: showSelect }"></i>
                </ui-frame-bg>
                <SelectList
                  class="switch-list"
                  :list="phaseList"
                  @handleSwitch="switchPhase"
                  v-show="showSelect"
                >
                </SelectList>
              </div>
            </div>
          </template>
          <template v-slot:container>
            <div class="arrange-box" ref="arrangeBox">
              <Arrange
                ref="arrange"
                :scoreModal="scoreModal"
                :teamsModal="teamsModal"
                :arrangeList="arrangeList"
                :handleAnchor="handleAnchor"
              >
              </Arrange>
            </div>
          </template>
        </ui-box>
      </div>
      <ScoreList ref="scoreModal"></ScoreList>
      <ParticipateTeams ref="teamsModal"></ParticipateTeams>

      <div class="rule-content" @click="showRule = false" v-if="showRule">
        <div
          class="content"
          :style="{
            'background-image': `url(${$lg(config, 'season_rule', '')})`,
            transform: `scale(${scale})`,
          }"
          @click="stopPropagation"
        >
          <div class="close" @click="showRule = false"></div>
        </div>
      </div>
      <modal-prize  ref="prize" /> 
      <ModalNotic  ref="notice" />
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as api from "@/service/index";
import UiBox from '@/components/ui-box';
import UiTag from '@/components/ui-tag';
import UiFrameBg from '@/components/ui-frame-bg';
import SelectList from "@/components/select";
import Arrange from "@/views/schedule/arrange";
import ScoreList from "@/views/schedule/scoreList";
import ParticipateTeams from "@/views/schedule/participateTeams";
import ModalPrize from '@/views/prize/modal/prize'
import ModalNotic from '@/views/schedule/notice'
import Apply from '@/views/apply/index';

export default {
  components: {
    UiBox,
    UiTag,
    UiFrameBg,
    SelectList,
    Arrange,
    ScoreList,
    ParticipateTeams,
    Apply,
    ModalPrize,
    ModalNotic
  },
  inject: ["json_config"],
  data() {
    return {
      dateZh: ["日", "一", "二", "三", "四", "五", "六"],
      seasonList: [],
      subSeason: {},
      subSeasonID: "",
      subSeasonRule: "",
      phaseList: [],
      arrangeList: [],
      currentTime: "",

      firstPhase: "",
      showSelect: false,
      subMatchName: "",
      // defaultID: '',
      showRule: false,
      partTeams: [],
    };
  },
  computed: {
    ...mapState(["uid", "token", "scale", "seasonInfo", "registration"]),
    config() {
      return this.json_config();
    },
  },
  watch: {
    seasonInfo: {
      handler(newVal) {
        if (newVal && newVal.id) {
          this.subSeasonID = newVal.id;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    if(!this.registration.switch || this.registration.testOtherModule) {
      this.requireSeasons();
    }
  },
  methods: {
    requireSeasons() {
      // 先请求赛季列表seasonList, 包含所有赛季，以及每个赛季设置的比赛阶段
      if(!this.token) return;
      api.reqArrangeSeasons({ token: this.token }).then((response) => {
        if (response.status == 200) {
          // 所以赛季信息
          this.seasonList = response.data;
          // console.log('this.seasonList',this.seasonList)
          // 获取当前服务器时间
          api.reqcurrentTime().then((response) => {
            if (response.status == 200) {
              this.currentTime = new Date(response.data).getTime();
            } else {
              this.currentTime = new Date();
            }
            this.switchSeason(this.subSeasonID);
          });
        } else {
          alert(response.data);
        }
      });
    },
    switchSeason(id) {
			let subSeason = this.seasonList.find((season) => season.id == id);
			if (subSeason) {
				// 当前赛季ID
				this.subSeasonID = subSeason.id;
				// 当前赛季规则
				this.subSeasonRule = subSeason.systemLink;
				// 当前赛季阶段
				this.phaseList = subSeason.categoryList || [];
				if (!this.phaseList.find((phase) => phase.id == "all")) {
					this.phaseList.unshift({
						id: "all",
						name: "全阶段",
					});
				}
				// 当前赛季安排
				let arrangeList = [];
				let temp_day_list = [];
				subSeason.scheduleList.forEach((schedule) => {
					// 格式化每天的安排
					let dateObj = new Date(schedule.startAt);
					let day = this.formatDay(dateObj);
					if (temp_day_list.indexOf(day) == -1) {
            let phase = this.phaseList.find(
							(phase) => phase.id == schedule.categoryId
						)
            if(!phase) return;

						let dayBox = {};
						dayBox.day = day;
						dayBox.week = `周${this.dateZh[dateObj.getDay()]}`;
						dayBox.title = phase.name;
						dayBox.categoryId = schedule.categoryId;

						dayBox.categoryList = [];

						arrangeList.push(dayBox);
						temp_day_list.push(day);
					}

					// 格式化每个赛程的安排
					let category = {};
					category.time = this.formatTime(dateObj);
					category.title = schedule.name;
					category.teams = schedule.teamList;
					if (this.currentTime < new Date(schedule.startAt)) {
						category.status = 1;
					} else if (
						this.currentTime >= new Date(schedule.startAt) &&
						this.currentTime <= new Date(schedule.endAt)
					) {
						category.status = 2;
					} else {
						category.status = 3;
					}
					category.scheduleCode = schedule.scheduleCode;

					// 添加到对应那天的赛程安排中
					arrangeList
						.find((arrange) => arrange.day == day)
						.categoryList.push(category);
				});
				this.arrangeList = arrangeList;
			}
    },
    formatDay(dateObj) {
      let month = dateObj.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      let day = dateObj.getDate();
      day = day < 10 ? "0" + day : day;

      return `${month}月${day}日`;
    },
    formatTime(dateObj) {
      let hour = dateObj.getHours();
      hour = hour < 10 ? "0" + hour : hour;
      let min = dateObj.getMinutes();
      min = min < 10 ? "0" + min : min;
      return `${hour}:${min}`;
    },
    switchPhase(id) {
      this.subMatchName = this.phaseList.find((item) => item.id == id).name;
      this.$refs.arrange.switchPhase(id);
      this.showSelect = false;

      // 埋点
      if (typeof tapdb == "undefined") return;
      tapdb.trackEvent("切换阶段");
    },
    scoreModal(code, title) {
      this.$refs.scoreModal.initMatchDetail(code, title);
    },
    stopPropagation(e) {
      e.stopPropagation();
    },
    teamsModal(teams) {
      this.$refs.teamsModal.initTeams(teams);
    },
    handleShowRule() {
      this.showRule = true;
    },
    handleAnchor(offsetLeft) {
      this.$refs.arrangeBox.scrollLeft = offsetLeft;
    },
     handleShowPrize() {
      this.$refs.prize.showModal()
    },
    handleShowNotice(){
      this.$refs.notice.showModal()
    }
  }
};
</script>

<style lang="scss">
@import "~@/assets/scss/schedule/index";
</style>